import { Col, Row } from "react-grid-system";
import { useParams } from "react-router-dom";
import Placeholder from "./Placeholder";
import IDevice from "../../models/devices/IDevice";
import { useEffect, useState } from "react";
import Status from "../../enums/Status";
import deviceService from "../../services/deviceService";
import { DetailsError as Error } from "./Error";
import { useTranslation } from "react-i18next";
import LAPS from "./LAPS";

const Details = (props: { device: IDevice }) => {
    const { t } = useTranslation();

    if (!props.device.manufacturer && !props.device.model && !props.device.serialNumber) {
        return null;
    }

    return (
        <Row>
            <Col xs={12}>
                <h3>{t("devices.titles.details")}</h3>
                <ul>
                    <li>
                        <strong>{t("devices.fields.manufacturer")}</strong>: {props.device.manufacturer}
                    </li>
                    <li>
                        <strong>{t("devices.fields.model")}</strong>: {props.device.model}
                    </li>
                    <li>
                        <strong>{t("devices.fields.serial")}</strong>: {props.device.serialNumber}
                    </li>
                </ul>
            </Col>
        </Row>
    );
};

export default function DeviceDetails() {
    const { deviceId } = useParams();

    const { t } = useTranslation();

    const [device, setDevice] = useState<IDevice>(null!);
    const [status, setStatus] = useState<Status>(Status.LOADING);

    const load = () => {
        setStatus(Status.LOADING);

        getDevice(deviceId!, setDevice)
            .then(() => setStatus(Status.LOAD_SUCCESS))
            .catch(() => setStatus(Status.LOAD_ERROR));
    };

    useEffect(load, [deviceId]);

    if (!deviceId) {
        return null;
    }

    return (
        <Row>
            <Col>
                <h2>
                    {
                        status === Status.LOAD_SUCCESS
                            ? device.name
                            : t("devices.titles.details")
                    }
                </h2>
                {
                    status === Status.LOADING &&
                    <Placeholder />
                }
                {
                    status === Status.LOAD_ERROR &&
                    <Error />
                }
                {
                    status === Status.LOAD_SUCCESS &&
                    <Row>
                        <Col xs={12}>
                            <Details device={device} />
                            <LAPS device={device} />
                        </Col>
                    </Row>
                }
            </Col>
        </Row>
    );
}

async function getDevice(
    deviceId: string,
    setDevice: (device: IDevice) => void
) {
    const device = await deviceService.getDevice(deviceId);
    setDevice(device);
}